export const jobQueryFormatter =
    (query) => Object.keys(query).sort().map(key => Array.isArray(query[key]) ? query[key].sort().join('') : query[key]).join('');

// export const alphanumericDate = (epoch) => {
//     const dt = new Date(epoch);
//     const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
//     return `${months[dt.getMonth()]} ${dt.getDate()}, ${dt.getFullYear()}`
// }
// export const alphanumericDate = (epoch) => {
//   if (!epoch) return '';

//   let dt;

//   if (typeof epoch === 'number') {
//     // seconds → ms
//     dt = new Date(epoch * 1000);
//   } else {
//     // ISO string
//     dt = new Date(epoch);
//   }

//   if (isNaN(dt)) return '';

//   const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

//   return `${months[dt.getMonth()]} ${dt.getDate()}, ${dt.getFullYear()}`;
// };
export const alphanumericDate = (epoch) => {
  if (!epoch) return '';

  let dt;

  if (typeof epoch === 'number') {
    // detect seconds vs milliseconds
    dt = new Date(epoch < 1e12 ? epoch * 1000 : epoch);
  } else {
    dt = new Date(epoch);
  }

  if (isNaN(dt)) return '';

  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];

  return `${months[dt.getMonth()]} ${dt.getDate()}, ${dt.getFullYear()}`;
};

export const howOldTimeUpdater = (time) => {
    if (!time) return "";

    let timestamp;

    if (typeof time === "string") {
        timestamp = new Date(time).getTime();
    } else {
        // if timestamp is in seconds (< 1e12), convert to ms
        timestamp = time < 1e12 ? time * 1000 : time;
    }

    const diffInSeconds = Math.floor((Date.now() - timestamp) / 1000);

    if (diffInSeconds < 60) return `${diffInSeconds} sec ago`;
    if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)} min ago`;
    if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)} hours ago`;
    if (diffInSeconds < 2592000) return `${Math.floor(diffInSeconds / 86400)} days ago`;
    if (diffInSeconds < 31536000) return `${Math.floor(diffInSeconds / 2592000)} months ago`;

    return `${Math.floor(diffInSeconds / 31536000)} years ago`;
};

